export default __webpack_public_path__ + "static/media/iconDownloadWhite.d2274354.svg";